module.exports = __webpack_public_path__ + "img/payroll-white.8cc01c45.svg";